// import images from "assets/images";
import ModalRestricted from 'components/ModalRestricted'
import { useGeoCheck } from 'controller/useGeoCheck'
import Footer from "layouts/Footer";
import HeaderNew from "layouts/HeaderNew";
import HeaderWallet from "layouts/HeaderWallet";
import HeaderStableCoin from "layouts/LayoutStable/HeaderStable";
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
// import Lottie from "react-lottie";
// import useResizeWidth from "controller/useResizeWidth";

// const defaultOptions = {
//   loop: true,
//   autoplay: true,
//   animationData: images.bdVicLottie,
//   rendererSettings: {
//     preserveAspectRatio: "xMidYMid slice",
//   },
// };

function LayoutContainer({ children }) {
  // const { positionY } = useResizeWidth();
  const { isRestricted } = useGeoCheck()
  const ftLayoutRef = React.useRef(null);
  const { pathname } = useLocation();

  const [isBannedPassed, setIsBannedPassed] = React.useState(() => {
    try {
      const isReload = performance.getEntriesByType("navigation")[0]?.type === "reload"
      if (isReload) {
        sessionStorage.removeItem('isBannedPassed')
        return false
      }
    } catch (e) {}
    return sessionStorage.getItem('isBannedPassed') === 'true'
  })
  const showRestricted = isRestricted && !isBannedPassed
  // const ftPosition = ftLayoutRef?.current?.offsetTop || 0;
  // const windowHeight = window.innerHeight || 0;

  const renderHeader = useMemo(() => {
    switch (pathname) {
      case "/stablecoins":
        return <HeaderStableCoin />;
      case "/wallet":
        return <HeaderWallet />;
      default:
        return <HeaderNew />;
    }
  }, [pathname]);

  return (
    <div className="layout-container">
      {renderHeader}
      {children}
      {/* <a
        href='https://dagora.xyz/new-releases/hotdrops/viction-turns-2-731-vms-and-counting'
        target='_blank'
        rel='noreferrer'>
        <div
          className={`bd-vic ${
            positionY + windowHeight >= ftPosition && 'bd-vic--stand'
          }`}>
          <div className={`bd-lottie`}>
            <Lottie options={defaultOptions} height={0} width={0} />
          </div>

          <img src={images.tower} alt='' className='bd-tower' />

          <div className='bd-content'>
            <div className='bd-content--title'>
              <img src={images.fingerV} className='finger-icon' alt='' />
              731 VMs
              <img src={images.fingerV} className='finger-icon' alt='' />
            </div>

            <div className='bd-content--text'>and Counting</div>
          </div>
        </div>
      </a> */}
      <div className="footer-layout" ref={ftLayoutRef}>
        <Footer />
      </div>

      <ModalRestricted
        isOpen={showRestricted}
        onConfirm={() => {
          setIsBannedPassed(true)
          sessionStorage.setItem('isBannedPassed', 'true')
        }}
      />
    </div>
  );
}

export default LayoutContainer;
